var map = {
	"./ania.jpg": 1005,
	"./ania_min.jpg": 1006,
	"./default.jpg": 1007,
	"./ewa.jpg": 1008,
	"./ewa_min.jpg": 1009,
	"./gabi.jpg": 1010,
	"./gabi_min.jpg": 1011,
	"./gosia.jpg": 1012,
	"./gosia_min.jpg": 1013,
	"./julia_r.jpg": 1014,
	"./julia_r_min.jpg": 1015,
	"./julia_wi.jpg": 1016,
	"./julia_wi_min.jpg": 1017,
	"./juliaw.jpg": 1018,
	"./juliaw_min.jpg": 1019,
	"./kaja.jpg": 1020,
	"./kaja_min.jpg": 1021,
	"./kamil.jpg": 1022,
	"./kamil_min.jpg": 1023,
	"./karolina.jpg": 1024,
	"./karolina_min.jpg": 1025,
	"./kinga.jpg": 1026,
	"./kinga_min.jpg": 1027,
	"./klaudia.jpg": 1028,
	"./klaudia_l.jpg": 1029,
	"./klaudia_l_min.jpg": 1030,
	"./klaudia_min.jpg": 1031,
	"./martyna.jpg": 1032,
	"./martyna_min.jpg": 1033,
	"./martynad.jpg": 1034,
	"./martynad_min.jpg": 1035,
	"./marysia.jpg": 1036,
	"./marysia_min.jpg": 1037,
	"./mati.jpg": 1038,
	"./mati_min.jpg": 1039,
	"./michalz.jpg": 1040,
	"./michalz_min.jpg": 1041,
	"./milosz.jpg": 1042,
	"./milosz_min.jpg": 1043,
	"./natalia.jpg": 1044,
	"./natalia_min.jpg": 1045,
	"./natalias.jpg": 1046,
	"./natalias_min.jpg": 1047,
	"./nataliaw.jpg": 1048,
	"./nataliaw2.jpg": 1049,
	"./nataliaw_min.jpg": 1050,
	"./nina.jpg": 1051,
	"./nina_min.jpg": 1052,
	"./ola_2.jpg": 1053,
	"./ola_k.jpg": 1054,
	"./ola_k_min.jpg": 1055,
	"./ola_min.jpg": 1056,
	"./olga.jpg": 1057,
	"./olga_min.jpg": 1058,
	"./patrycja.jpg": 1059,
	"./patrycja_min.jpg": 1060,
	"./piotrek.jpg": 1061,
	"./piotrek_min.jpg": 1062,
	"./sebastian.jpg": 1063,
	"./sebastian2.jpg": 1064,
	"./sebastian2_min.jpg": 1065,
	"./sebastian_min.jpg": 1066,
	"./szymon.jpg": 1067,
	"./szymon_min.jpg": 1068,
	"./weronika.jpg": 1069,
	"./weronika_d.jpg": 1070,
	"./weronika_d_min.jpg": 1071,
	"./weronika_min.jpg": 1072,
	"./wiktoria.jpg": 1073,
	"./wiktoria_min.jpg": 1074,
	"./zdjecia zarzad+koo.rar": 1075
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;